import { type FunctionComponent, useRef } from 'react';
import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { toViewpointModeMainViewInstanceId } from 'appLayout/mainViewInstanceIds';
import { getViewpointModeViewSettingsWithChanges$ } from 'views/environmentals/viewSettings/viewpointModeViewSettings$';
import { HierarchicalPackingVisualization } from '../view/packing/HierarchicalPackingVisualization';
import { HierarchicalViewpointShell } from './HierarchicalViewpointShell';
import { getViewpointViewModel$ } from './viewpointViewModel$';
import type { HierarchicalViewpointViewProperties } from './types';

const VIEW_ID = ViewIds.HIERARCHICAL_PACKING;
const VIEW_INSTANCE_ID = toViewpointModeMainViewInstanceId(VIEW_ID);

/** Circle packing in viewpoint mode. See {@link HierarchicalTreemapViewpointView}. */
const HierarchicalPackingViewpointView = (
  props: HierarchicalViewpointViewProperties
) => {
  const {
    sizedNodes,
    viewSettings: { maxDepth },
    formatValue,
  } = props;
  const viewContainer = useRef<HTMLDivElement>(null);

  return (
    <HierarchicalViewpointShell
      viewId={ViewIds.HIERARCHICAL_PACKING}
      properties={props}
      viewContainer={viewContainer}
    >
      <HierarchicalPackingVisualization
        sizedNodes={sizedNodes}
        maxDepth={maxDepth}
        formatValue={formatValue}
        viewContainer={viewContainer}
        i18nLocale={props.i18nLocale}
      />
    </HierarchicalViewpointShell>
  );
};

const ConnectedHierarchicalPackingViewpointView: FunctionComponent = connect(
  HierarchicalPackingViewpointView,
  getViewpointViewModel$({
    viewId: VIEW_ID,
    viewInstanceId: VIEW_INSTANCE_ID,
    viewSettingsWithChanges$: getViewpointModeViewSettingsWithChanges$(
      VIEW_ID,
      VIEW_INSTANCE_ID
    ),
  })
);

export {
  HierarchicalPackingViewpointView,
  ConnectedHierarchicalPackingViewpointView,
};
